import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { BondRequestModel } from '@data-layer/models/common';
import { enumBondRequestState, enumBondType } from '@data-layer/enums/common';
import { enumCardStyle } from '@shared/cards/enums';
import { enumPaymentState } from '@data-layer/enums/payments';
import { enumDropdownActionMenuMode } from '@shared/form-wrapper/enums';

@Component({
  selector: 'company-bond-request-card',
  templateUrl: './company-bond-request-card.component.html',
  styleUrls: ['./company-bond-request-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyBondRequestCardComponent implements OnInit, OnChanges {
  @Input() public bondRequest: BondRequestModel;
  @Output() public delete: EventEmitter<boolean> = new EventEmitter<boolean>();

  public cardStyle: enumCardStyle = enumCardStyle.SECONDARY;
  public menuMode: enumDropdownActionMenuMode = enumDropdownActionMenuMode.LIGHT;
  public openDeleteModal: boolean = false;
  public isCustomState = false;

  constructor() {}

  public ngOnInit(): void {
    this.isCustomState = this.bondRequest.state === enumBondRequestState.CUSTOM;
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.bondRequest) {
      this.isCustomState = this.bondRequest?.state === enumBondRequestState.CUSTOM;
    }
  }

  public get canDelete() {
    return this.bondRequest.state === enumBondRequestState.CREATED;
  }

  public get canEdit(): boolean {
    return this.bondRequest.state !== enumBondRequestState.SENT;
  }

  public get canView() {
    return true;
  }

  public get bondName() {
    switch (this.bondRequest.bondType) {
      case enumBondType.CONTINUOUS:
        return 'BOND_TYPE.CONTINUOUS';
      case enumBondType.SINGLE_TRANSACTION:
        return 'BOND_TYPE.SINGLE_TRANSACTION';
      default:
        return '';
    }
  }

  public get bondClassName(): string {
    switch (this.bondRequest.state) {
      case enumBondRequestState.CREATED:
        return 'created';
      case enumBondRequestState.SENT:
        return 'sent';
      case enumBondRequestState.CUSTOM:
        return 'custom';
    }
  }

  public get bondPaymentStateName() {
    if ([null, undefined].includes(this.bondRequest.paymentState)) {
      return 'PAYMENT_STATE.NOT_PAID';
    }
    return 'PAYMENT_STATE.' + enumPaymentState[this.bondRequest.paymentState];
  }

  public checkPayment() {
    if ([enumPaymentState.SUCCESS, enumPaymentState.DELAYED].includes(this.bondRequest.paymentState)) {
      this.openDeleteModal = true;
    } else {
      this.delete.emit();
    }
  }

  public onDelete() {
    this.delete.emit();
  }

  public onDecline() {
    this.openDeleteModal = false;
  }
}
